/*
 *
 * Copyright (c) 2020 TenderHub LLC. All rights reserved
 *
 * This software is the confidential and proprietary information of
 * TenderHub LLC ("Confidential Information"). You shall not disclose
 * such Confidential Information.
 *
 */

import { ExecuteActionResponse, HttpMethod } from '@site-shared/common';
import { CoreLibModuleBuilder } from '@site-shared/core';
import {
	RegistrationEndpoints,
	WhiteLabelAcceptRequest,
	WhiteLabelSignonRequest,
} from '@site-shared/data';
import { LocalStorageService } from 'ngx-webstorage';
import { environment } from '../environments/environment';

export function configureCore(): (builder: CoreLibModuleBuilder) => void {
	return (builder: CoreLibModuleBuilder) => {
		builder
			.withEndpoint(RegistrationEndpoints.SIGNON, (endpoint) => {
				endpoint.pathFormat = environment.endpoints[RegistrationEndpoints.SIGNON];
				endpoint.httpMethod = HttpMethod.POST;
				endpoint.request = WhiteLabelSignonRequest;
				endpoint.response = ExecuteActionResponse;
			})
			.withEndpoint(RegistrationEndpoints.ACCEPT, (endpoint) => {
				endpoint.pathFormat = environment.endpoints[RegistrationEndpoints.ACCEPT];
				endpoint.httpMethod = HttpMethod.POST;
				endpoint.request = WhiteLabelAcceptRequest;
				endpoint.response = ExecuteActionResponse;
			})
			.withStorage(LocalStorageService);
	};
}
